import { NULLADDRESS } from '@src/configs/chainInfo'
import { ChainId } from '@src/configs/chainInfo'
import { Address, IToken } from '@src/types/token'
import { isFeatureEnabled } from '@src/utils/environment'

// Testnet defaults
// Test comment
const TESTNET_SELL_TOKEN: IToken = {
    address: NULLADDRESS as Address,
    symbol: 'MON',
    name: 'MON',
    logoURI: '/assets/token/mon.png',
    price_current: 1,
    decimals: 18,
    chainId: ChainId.MonadTestnet,
    native: true,
}

const TESTNET_BUY_TOKEN: IToken = {
    address: '0x7169D38820dfd117C3FA1f22a697dBA58d90BA06' as Address,
    symbol: 'USDT',
    name: 'USDT',
    logoURI: 'https://assets.coingecko.com/coins/images/325/standard/Tether.png?1696501661',
    price_current: 1,
    decimals: 6,
    chainId: ChainId.Sepolia,
    native: false,
}

// Mainnet defaults
const MAINNET_SELL_TOKEN: IToken = {
    address: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831' as Address,
    symbol: 'USDC',
    name: 'USDC',
    logoURI: 'https://coin-images.coingecko.com/coins/images/6319/large/usdc.png?1696506694',
    price_current: 0.999944,
    decimals: 6,
    chainId: ChainId.Arbitrum,
    native: false,
}

const MAINNET_BUY_TOKEN: IToken = {
    address: '0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a' as Address,
    symbol: 'AUSD',
    name: 'AUSD',
    logoURI:
        'https://coin-images.coingecko.com/coins/images/39284/large/Circle_Agora_White_on_Olive_1080px.png?1722961274',
    price_current: 0.999206,
    decimals: 6,
    chainId: ChainId.Avalanche,
    native: false,
}

export const DEFAULT_SELL_TOKEN: IToken = isFeatureEnabled('USE_TESTNETS_ONLY')
    ? TESTNET_SELL_TOKEN
    : MAINNET_SELL_TOKEN

export const DEFAULT_BUY_TOKEN: IToken = isFeatureEnabled('USE_TESTNETS_ONLY') ? TESTNET_BUY_TOKEN : MAINNET_BUY_TOKEN
